import React from 'react';
import AboutContent from '../../components/AboutContent';
import ContentImg from '../../components/ContentImg';
import ClientList from '../../components/ClientList';
import LeftRightContent from '../../components/LeftRightContent';
import Title from '../../components/Title';
import house from '../../assets/house-alt.svg';

function AboutFeature() {
  return (
    <>
      <Title text="About Us - Tenant Portal" />
      <LeftRightContent
        bgcolor="light"
        heading="About Us"
        subheading="Use your Tenant Profile to apply for Tenancies."
        content={<AboutContent />}
        rightContent={<ContentImg animation="zoomIn" src={house} />}
      />
      <ClientList />
    </>
  );
}

export default AboutFeature;
